(function($){

	"use strict";

	window.breakpoint = '';

	var breakpointIdentifier = $('#breakpoint-identifier');

	var updateBreakpoint = function() {

		var currentBreakpoint = window.getComputedStyle(document.querySelector('#breakpoint-identifier'), ':before').getPropertyValue('content').replace(/\"|\'/g, '');
			//$("#breakpoint-identifier:before").css("content").replace(/\"/g, '');

		if (currentBreakpoint != window.breakpoint) {
			window.breakpoint = currentBreakpoint;
			$(window).trigger('breakpointChange');
		}
	};

	$(window).on('resize', breakpointIdentifier, updateBreakpoint);

	updateBreakpoint();

	window.isBreakpoint = function (breakpoint) {
		return (window.breakpoint == breakpoint);
	}

})(window.jQuery);
